import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { PositionService } from '../../../position.service';

@Component({
  selector: 'app-shift-item-info',
  templateUrl: './shift-item-info.component.html',
  styleUrls: ['./shift-item-info.component.scss']
})
export class ShiftItemInfoComponent implements OnInit {

  inspName: any = '';
  inspId: any = '';
  inspAgency: any = '';
  inspEmail: any = '';
  inspPhone: any = '';
  startTime: any = '';
  endTime: any = '';
  isStartTimeEdit = false;
  isEndTimeEdit = false;
  startInfo = {
    hours: '',
    minutes: ''
  };
  endInfo = {
    hours: '',
    minutes: ''
  };
  isStartTimeLoading = false;
  isEndTimeLoading = false;
  insyncPositionId: number = -1;

  constructor(
    public dialogRef: MatDialogRef<ShiftItemInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public info: any,
    public dialog: MatDialog,
    private positionService: PositionService
  ) { }

  ngOnInit() {
    this.inspName = this.info.info.assignments[0].inspectorName;
    this.inspId = this.info.info.assignments[0].inspectorId;
    this.inspAgency = this.info.info.assignments[0].inspAgency;
    this.inspEmail = this.info.info.assignments[0].inspEmail;
    this.inspPhone = this.info.info.assignments[0].inspPhone;

    this.startTime = this.info.info.start;
    this.endTime = this.info.info.end;

    this.insyncPositionId = this.info.info.id;
    this.startInfo.hours = this.startTime.split(':')[0];
    this.startInfo.minutes = this.startTime.split(':')[1];
    this.endInfo.hours = this.endTime.split(':')[0];
    this.endInfo.minutes = this.endTime.split(':')[1];

    const em = <HTMLLinkElement> document.getElementById('emailHref');
    em.href = 'mailto:' + this.inspEmail;
    const ph = <HTMLLinkElement> document.getElementById('phoneHref');
    ph.href = 'tel:+1' + this.inspPhone;
  }

  closeClicked() {
    this.dialogRef.close({ result: 'cancelled', startTime: this.startTime, endTime: this.endTime });
  }

  setStartTimeCheck() {
    const start = `${this.pad(Number(this.startInfo.hours))}:${this.pad(Number(this.startInfo.minutes))}`;
    const end = this.endTime;

    this.isStartTimeLoading = true;
    this.positionService.updateStartAndEndTimeForPosition(start, end, this.insyncPositionId)
      .subscribe(() => {
        this.startTime = `${this.pad(Number(this.startInfo.hours))}:${this.pad(Number(this.startInfo.minutes))}`;
        this.isStartTimeEdit = false;
        this.isStartTimeLoading = false;
      },
      (error) => {
        console.log({ error })
        this.startInfo.hours = this.startTime.split(':')[0];
        this.startInfo.minutes = this.startTime.split(':')[1];
        this.isStartTimeEdit = false;
        this.isStartTimeLoading = false;
      })
  }

  resetStartTimeInputs() {
    this.isStartTimeEdit = false;
    this.startInfo.hours = this.startTime.split(':')[0];
    this.startInfo.minutes = this.startTime.split(':')[1];
  }

  onStartTimeChange(type: 'hours' | 'minutes') {
    const value = type === 'hours'
      ? this.startInfo.hours
      : this.startInfo.minutes;

    // Allow empty while typing
    if (value === '') return;

    // Numeric only
    if (!/^\d{1,2}$/.test(value)) {
      this.revertStartOrEndTime(type);
      return;
    }

    const num = Number(value);

    if (type === 'hours' && (num < 0 || num > 23)) {
      this.revertStartOrEndTime(type);
      return;
    }

    if (type === 'minutes' && (num < 0 || num > 59)) {
      this.revertStartOrEndTime(type);
      return;
    }
  }

  setEndTimeCheck() {
    const start = this.startTime;
    const end = `${this.pad(Number(this.endInfo.hours))}:${this.pad(Number(this.endInfo.minutes))}`;

    this.isEndTimeLoading = true;

    this.positionService.updateStartAndEndTimeForPosition(start, end, this.insyncPositionId)
      .subscribe(() => {
        this.endTime = `${this.pad(Number(this.endInfo.hours))}:${this.pad(Number(this.endInfo.minutes))}`;
        this.isEndTimeEdit = false;
        this.isEndTimeLoading = false;
      },
      (error) => {
        console.log({ error })
        this.endInfo.hours = this.endTime.split(':')[0];
        this.endInfo.minutes = this.endTime.split(':')[1];
        this.isEndTimeEdit = false;
        this.isEndTimeLoading = false;
      })
  }

  resetEndTimeInputs() {
    this.isEndTimeEdit = false;
    this.endInfo.hours = this.endTime.split(':')[0];
    this.endInfo.minutes = this.endTime.split(':')[1];
  }

  onEndTimeChange(type: 'hours' | 'minutes') {
    const value = type === 'hours'
      ? this.endInfo.hours
      : this.endInfo.minutes;

    // Allow empty while typing
    if (value === '') return;

    // Numeric only
    if (!/^\d{1,2}$/.test(value)) {
      this.revertStartOrEndTime(type, false);
      return;
    }

    const num = Number(value);

    if (type === 'hours' && (num < 0 || num > 23)) {
      this.revertStartOrEndTime(type, false);
      return;
    }

    if (type === 'minutes' && (num < 0 || num > 59)) {
      this.revertStartOrEndTime(type, false);
      return;
    }
  }
  
  private revertStartOrEndTime(type: 'hours' | 'minutes', isStart: boolean = true) {
    const [h, m] = isStart ? this.startTime.split(':') : this.endTime.split(':');
    if (type === 'hours') {
      if (isStart) {
          this.startInfo.hours = h;
      } else {
        this.endInfo.hours = h;
      }
    } else {
      if (isStart) {
        this.startInfo.minutes = m;
      } else {
        this.endInfo.minutes = m;
      }
    }
  }

  private pad(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
